<div class="chat-layout">
  <button class="chat-close-btn" (click)="closeChat.emit()">
    <span class="material-symbols-outlined">close</span>
  </button>

  <aside class="chat-sidebar-panel">
    <app-chat-sidebar
      (chatSelected)="onChatSelected($event)"
      (userSelected)="onUserSelected($event)"
      (searchChanged)="onSearchChanged($event)"
      (createGroupClicked)="createGroupModal.open()"
    />
  </aside>

  <main class="chat-content-panel">
    @if (state.selectedChat()) {
      <app-chat-header
        [chat]="state.selectedChat()!"
        (groupInfoClicked)="onShowGroupInfo()"
        (editGroupClicked)="onShowEditGroup()"
      />

      <app-chat-messages
        class="chat-messages"
        (loadMore)="onLoadMoreMessages()"
        (deleteMessage)="onDeleteMessage($event)"
        (openLightbox)="onOpenLightbox($event)"
        (saveEdit)="onSaveEdit($event)"
      />

      <app-chat-input
        (sendMessage)="onSendMessage($event)"
        (sendFile)="onSendFile($event)"
        (typing)="onTyping($event)"
      />
    } @else {
      <div class="empty-state">
        <span class="material-symbols-outlined empty-icon">chat_bubble</span>
        <p class="empty-text">{{ translateService.getTranslation(4136) }}</p>
      </div>
    }
  </main>
</div>

<app-chat-lightbox />
<app-create-group-modal (create)="onCreateGroup($event)" />
<app-edit-group-modal (save)="onSaveGroupEdit($event)" />
<app-group-info-modal />
